export default __webpack_public_path__ + "2af012978cf20fc7f47158b5445455f6.png";